import { ColumnTable, Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ChargeItem } from '../api';

const dictPrefix = 'financialPortal.settings.chargeItems';

interface Options {
  onEdit: (item: ChargeItem) => void;
  onDelete: (item: ChargeItem) => void;
}

export function useChargeItemColumns({
  onEdit,
  onDelete,
}: Options): ColumnTable<ChargeItem>[] {
  const { t } = useTranslation();

  return useMemo<ColumnTable<ChargeItem>[]>(
    () => [
      {
        columnName: 'name',
        headerText: t(`${dictPrefix}.columns.name`),
        thClassName: 'text-left',
        tdClassName: 'text-left',
      },
      {
        columnName: 'code',
        headerText: t(`${dictPrefix}.columns.code`),
        thClassName: 'text-left',
        tdClassName: 'text-left',
      },
      {
        columnName: 'id',
        headerText: t(`${dictPrefix}.columns.action`),
        thClassName: 'text-right',
        tdClassName: 'text-right',
        width: '15%',
        cellFormat: ({ row }) => (
          <div className="d-flex justify-content-end" style={{ gap: 8 }}>
            <button
              type="button"
              className="btn p-0"
              aria-label={t(`${dictPrefix}.edit`)}
              title={t(`${dictPrefix}.edit`)}
              onClick={() => onEdit(row)}
            >
              <Icon size="15" name="edit" color="primary" />
            </button>
            <button
              type="button"
              className="btn p-0"
              aria-label={t(`${dictPrefix}.delete`)}
              title={t(`${dictPrefix}.delete`)}
              onClick={() => onDelete(row)}
            >
              <Icon size="15" name="trash" color="primary" />
            </button>
          </div>
        ),
      },
    ],
    [t, onEdit, onDelete],
  );
}
